const { get, find } = require('lodash');
const getValue = require('../get-value');

const toStringLookup = function(value, { references, fieldId }) {
  const { moduleId, records } = value || {}; // protects against value: null
  const moduleDetails = get(references, [moduleId], {});
  const primaryField = find(
    get(moduleDetails, 'fields.fields', get(moduleDetails, 'fields', [])),
    {
      id: fieldId
    }
  );

  if (!primaryField || !records || !records.length) {
    return '';
  }

  return records
    .map(recordId => {
      const record = get(moduleDetails, ['records', recordId], {});
      // @NOTE: Don't require until necessary to prevent circular dependency on reports
      // @NOTE: In some cases the values are returned on record itself (not the values dict),
      // so we also check against that here
      return require('../to-string')(
        getValue(
          get(record, ['values', primaryField.id]) || record[primaryField.id],
          primaryField.type
        ),
        primaryField.type
      );
    })
    .join(', ');
};

module.exports = toStringLookup;
